import {
    collection,
    doc,
    documentId,
    getDocs,
    limitToLast,
    orderBy,
    query,
    runTransaction,
    where
} from "firebase/firestore";
import db from "./firebase";


const checkins = collection(db, "checkins");

const gymOpenStatus = doc(db, 'status', 'open')

const tempInfo = collection(db, 'status', 'generalinfo', 'wifitemperator')

const gymOpener = (closed) => query(
  doc(db, "logs", closed || "open"),
  orderBy(documentId(), 'desc'),
  limitToLast(1)
)


const getGymOpener = async () => new Promise( (resolve, ) => {
  const opener = getDocs(gymOpener)
  if (!opener.empty) {
    resolve(opener.docs[0].data())
  } else {
      resolve({})
  }
})

const getUserBeaconByRole = (role) => collection(db, 'staybeacons', 'roles', role)

const getSpotifyAuthToken = () => doc(db, "tokens", 'spotify');

const getInfoMedia = () => doc(db, "info", 'media');

const getAll = () => checkins;

const getOfHour = (timestamp) => collection(db, "checkins", timestamp, "users");

const getAfterHour = (timestamp) => query(
  collection(db, "checkins"),
  orderBy(documentId()),
  where(documentId(), ">=", timestamp)
)

const viewCheckinRequest = (id) => collection(db, 'viewcheckinrequests', id)

// timestamp, "users"

const getCountOfHour = (timestamp) => doc(db, "checkinCounts", timestamp);

const getCountAfterHour = (timestamp) => query(
  collection(db, "checkinCounts"),
  orderBy(documentId()),
  where(documentId(), ">=", timestamp)
)

const getCountOfDay = (timestamp) => query(
  collection(db, "checkinCounts", ),
  orderBy(documentId()),
  where(documentId(), ">=", timestamp)
) ;

const getMessageOfDay = (timestamp) => 
  // // console.log('timestamp', timestamp);
   doc(db, "messageoftheday", timestamp)

const createCheckin = async (data) => {
  const { timestamp, user, checkintype } = data
  // console.log('timestamp',timestamp);
  console.log('user',user);

  try {
    await runTransaction(db, async (transaction) => {
      const countDocRef = doc(db, "checkinCounts", timestamp)

      const count = await transaction.get(countDocRef);

      transaction.set(doc(db, "checkins", timestamp, "users", user.id), user)
      if (count.exists && count.data()) {
        transaction.update(countDocRef, {
          count: Number(count.data().count) + 1,
          [checkintype]: Number(count.data()[checkintype] || 0) + 1
        })
      } else {
        transaction.set(countDocRef, {
          count: 1,
          [checkintype]: 1
        })
      }
      
    });
    console.log("Transaction successfully committed!");
  } catch (e) {
    console.log("Transaction failed: ", e);
  } 
};



const create = (data) => checkins.add(data);

const update = (id, value) => checkins.doc(id).update(value);

const remove = (id) => checkins.doc(id).delete();

const CheckinsService = {
  getAll,
  getOfHour,
  getAfterHour,
  getCountOfHour,
  getCountAfterHour,
  getCountOfDay,
  getMessageOfDay,
  gymOpenStatus,
  tempInfo,
  getGymOpener,
  getUserBeaconByRole,
  getSpotifyAuthToken,
  getInfoMedia,
  viewCheckinRequest,
  create,
  createCheckin,
  update,
  remove
};

export default CheckinsService;